import styles from "./Divider.css";

/**
 * A horizontal rule between sections. Renders an `<hr>`, which already carries
 * the separator role, so screen readers announce the break without extra ARIA.
 */
const Divider = () => <hr className={styles.divider} />;

export default Divider;
